import { BasketballSubLogTypes } from '../models/basketball-game-log';
import { Locales } from './locales';

export const BasketballGameSubLogTypesLocalization = {
  [Locales.ru]: {
    // Shots
    [BasketballSubLogTypes.jump_shot]: 'Джампшот',
    [BasketballSubLogTypes.step_back_jump_shot]: 'Степ-бэк',
    [BasketballSubLogTypes.floating_jump_shot]: 'Флоатинг',
    [BasketballSubLogTypes.fade_away_jump_shot]: 'Фэйдавэй',
    [BasketballSubLogTypes.pull_up_jump_shot]: 'Пуллап',
    [BasketballSubLogTypes.turnaround_jump_shot]: 'Турнэраунд',
    [BasketballSubLogTypes.dunk]: 'Данк',
    [BasketballSubLogTypes.layup]: 'Лэйап',
    [BasketballSubLogTypes.driving_layup]: 'Драйвинг лэйап',
    [BasketballSubLogTypes.alley_oop]: 'Алейуп',
    [BasketballSubLogTypes.hook_shot]: 'Хукшот',

    // foul
    [BasketballSubLogTypes.offensive_foul]: 'В нападении',
    [BasketballSubLogTypes.shot_foul]: 'При броксе',
    [BasketballSubLogTypes.mutual_foul]: 'Обоюдный фол',

    // Turnover
    [BasketballSubLogTypes.bad_pass]: 'Плохой пас',
    [BasketballSubLogTypes.ball_handling]: 'На ведении',
    [BasketballSubLogTypes.travel]: 'Пробежка',
    [BasketballSubLogTypes.double_dribble]: 'Двойное ведение',
    [BasketballSubLogTypes.out_of_bounds]: 'Заступ в аут',
    [BasketballSubLogTypes.three_seconds]: '3 секунды',
    [BasketballSubLogTypes.five_seconds]: '5 секунд',
    [BasketballSubLogTypes.eight_seconds]: '8 секунд',
    [BasketballSubLogTypes.twenty_four_seconds]: '24 секунды',
    [BasketballSubLogTypes.back_court]: 'Зона',
    [BasketballSubLogTypes.offensive_goal_tending]: 'Гоалтендинг',
    [BasketballSubLogTypes.other_turnover]: 'Другое',
  },
  [Locales.en]: {
    // Shots
    [BasketballSubLogTypes.jump_shot]: 'Jump shot',
    [BasketballSubLogTypes.step_back_jump_shot]: 'Step back',
    [BasketballSubLogTypes.floating_jump_shot]: 'Floating',
    [BasketballSubLogTypes.fade_away_jump_shot]: 'Fade-away',
    [BasketballSubLogTypes.pull_up_jump_shot]: 'Pull-up',
    [BasketballSubLogTypes.turnaround_jump_shot]: 'Turnaround',
    [BasketballSubLogTypes.dunk]: 'Dunk',
    [BasketballSubLogTypes.layup]: 'Layup',
    [BasketballSubLogTypes.driving_layup]: 'Driving layup',
    [BasketballSubLogTypes.alley_oop]: 'Alley-oop',
    [BasketballSubLogTypes.hook_shot]: 'Hook-shot',

    // foul
    [BasketballSubLogTypes.offensive_foul]: 'Offensive foul',
    [BasketballSubLogTypes.shot_foul]: 'Shot foul',
    [BasketballSubLogTypes.mutual_foul]: 'Mutual foul',

    // Turnover
    [BasketballSubLogTypes.bad_pass]: 'Bad pass',
    [BasketballSubLogTypes.ball_handling]: 'Ball handling',
    [BasketballSubLogTypes.travel]: 'Travel',
    [BasketballSubLogTypes.double_dribble]: 'Double dribble',
    [BasketballSubLogTypes.out_of_bounds]: 'Out of bounds',
    [BasketballSubLogTypes.three_seconds]: '3 second',
    [BasketballSubLogTypes.five_seconds]: '5 second',
    [BasketballSubLogTypes.eight_seconds]: '8 second',
    [BasketballSubLogTypes.twenty_four_seconds]: '24 second',
    [BasketballSubLogTypes.back_court]: 'Back court',
    [BasketballSubLogTypes.offensive_goal_tending]: 'Goal tending',
    [BasketballSubLogTypes.other_turnover]: 'Other',
  }
};
